<!--节能评估
日周月季年的负荷率
负荷率为合相有功功率除以额定功率（额定负荷只有变压器有而且一般是一样的）
-->
<template>
  <div class="energySaving">
    <div class="con">
      <div class="tree-left">
        <elUnitTree
          @checkFun="search"
          :dataList="readDeviceTreeList"
        ></elUnitTree>
      </div>
      <div class="right-table">
        <div class="search-input-btn" style="width:100%">
          <el-scrollbar style="height:100%;width: 100%;">
            <div class="my-search-i">
              <div class="input-small  myinput">
                <span></span>
                <el-select
                  v-model="apptype"
                  placeholder="请选择"
                  @change="select_fn"
                  style="margin-right:20px"
                >
                  <el-option
                    v-for="item in apptypeGroups"
                    :key="item.no"
                    :label="item.name"
                    :value="item.no"
                  ></el-option>
                </el-select>
              </div>
              <div class="input-small mr-20 myinput">
                <span></span>
                <el-select v-model="radioSelect" placeholder="请选择">
                  <el-option
                    v-for="item in timestype"
                    :key="item.en"
                    :label="item.ch"
                    :value="item.en"
                  ></el-option>
                </el-select>
              </div>
              <div class="input-small">
                <span></span>
                <el-date-picker
                  v-show="radioSelect == 'day'"
                  v-model="serchTime"
                  type="date"
                  placeholder="选择日期"
                  :picker-options="pickerOptions"
                ></el-date-picker>
                <el-date-picker
                  v-show="radioSelect == 'month' || radioSelect == 'quarter'"
                  v-model="serchTime"
                  type="month"
                  placeholder="选择月"
                  :picker-options="pickerOptions"
                ></el-date-picker>
                <el-date-picker
                  v-show="radioSelect == 'year'"
                  v-model="serchTime"
                  type="year"
                  placeholder="选择年"
                  :picker-options="pickerOptions"
                ></el-date-picker>
              </div>
              <el-button type="primary" plain @click="search" class="search-btn"
                >查询</el-button
              >
              <el-button
                @click="downloadExcel"
                type="primary"
                class="search-btn"
                >导出</el-button
              >
            </div>
          </el-scrollbar>
        </div>
        <div class="mychart" style="width:100%;height:450px">
          <vchart style="height: 100%;" ref="vchart"></vchart>
        </div>
        <el-table
          :data="nowShowDataList"
          border
          :max-height="heights"
          stripe
          style="width: 100%;margin-top:20px"
        >
          <el-table-column label="序号" width="60" align="center" fixed>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据" />
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="0" label="名称" width="250" fixed>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in columns"
            :prop="(index + 1).toString()"
            :label="item.name"
            :key="item.key"
            :width="item.width"
          >
          </el-table-column>
        </el-table>
        <div class="el-loading-mask" v-show="loading">
          <div class="el-loading-spinner">
            <svg viewBox="25 25 50 50" class="circular">
              <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import vchart from "@/components/module/chart/vchart.vue";
import elUnitTree from "@/components/module/newTree/elUnitTree.vue";
export default {
  components: {
    vchart,
    elUnitTree,
  },
  props: [],
  data() {
    return {
      loading: false,
      heights: Math.round(document.getElementById("app").clientHeight * 0.32),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      radioSelect: "day",
      timestype: [
        {
          ch: "日",
          en: "day",
        },

        {
          ch: "月",
          en: "month",
        },
        // {
        //   ch: '季',
        //   en: 'quarter'
        // },
        {
          ch: "年",
          en: "year",
        },
      ],
      dataObject: {},
      nowApptypeGroup: { name: "用电日负荷", no: -1 }, //默认为第一个
      options: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {
          data: [],
          bottom: 0,
        },
        grid: {
          top: 40,
          left: 50,
          right: 15,
          bottom: 30,
          containLabel: true,
        },
        xAxis: {
          splitLine: {
            //网格线
            show: true,
          },
          type: "category",

          axisTick: {
            show: false,
          },
          axisLabel: {
            interval: 0,
            rotate: 0,
            inside: false,
          },
          axisLine: {
            show: false,
          },
          data: [],
        },
        title: {
          left: "left",
          text: "",
          textStyle: {
            color: "#1a1a1a",
            fontSize: 16,
            fontWeight: "normal",
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#CCCCCC",
            },
          },
          type: "value",
        },
        series: [],
      },
      apptype: -1,
      from2name: {},
      variableToDeviceNo: {},
      warnMessage: "",
      nowapptypeGroups: -2,

      serchTime: new Date(),
      fromName: {},
      nowVirtualDevice: [],
      nowVirtualDeviceList: [],
      dayDateList: [],
      monDateList: [],
      yearDateList: [],
      mynum: 1,
    };
  },
  created() {},
  mounted() {
    for (let i = 0; i <= 23; i++) {
      this.dayDateList.push(i < 10 ? "0" + i + ":00" : i + ":00");
    }
    for (let i = 1; i <= 31; i++) {
      this.monDateList.push(i + "日");
    }
    for (let i = 1; i <= 12; i++) {
      this.yearDateList.push(i + "月");
    }
    debugPage = this;
    //初始化图表
    this.$refs.vchart.setData(this.options, true);
    this.search();
  },
  destroyed() {},
  computed: {
    nowUnit() {
      return this.$store.unitStore.getters.getNowUnit;
    },
    getOnedeviceNoToVariableTree() {
      return (no) => {
        return this.$store.variableStore.getters.getdeviceNoToVariableTree(no);
      };
    },
    readDeviceTreeList() {
      var data = this.$store.deviceStore.getters.getReadDeviceTree;
      return isempty(data) ? [] : [deviceList(data)];
      var str = "31,237,361";
      var data = [
        {
          children: [
            {
              children: [
                {
                  children: [
                    {
                      no: 11,
                      pkid: "8583043e9afc486a98e946651c4516c7",
                      archivesTypeCode: "1",
                      parentarea: 0,
                      channel: 4,
                      archivesId: "6155707d872349e69ee451de9b390ec1",
                      sort: 3,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 934,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "设备机电总进线数显表",
                      id: "11",
                    },
                    {
                      no: 13,
                      pkid: "8785a6448b3b480e978fdfb5bed5bbee",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 4,
                      archivesId: null,
                      sort: 4,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 1211,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "水元一4011电线1211",
                      id: "13",
                    },
                    {
                      no: 16,
                      pkid: "3ea8f3d3f19c420db570806a0f77a968",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 4,
                      archivesId: null,
                      sort: 5,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 1215,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "气元一4033厂房",
                      id: "16",
                    },
                    {
                      no: 19,
                      pkid: "08fd6f83f6c24eed8b33e393fd8c5f76",
                      archivesTypeCode: "Transformer",
                      parentarea: 0,
                      channel: 4,
                      archivesId: "f0d7da5dfbfc4022a7c76de2d3702252",
                      sort: 6,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 23,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "英派尔预付费表",
                      id: "19",
                    },
                    {
                      no: 20,
                      pkid: "ea261b4de661498f887476da9635cd44",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 4,
                      archivesId: null,
                      sort: 7,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 6,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "水表",
                      id: "20",
                    },
                    {
                      no: 1,
                      pkid: "a18fcaaf12514485975e844435536fcb",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 4,
                      archivesId: null,
                      sort: 9,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 640,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "益大",
                      id: "1",
                    },
                    {
                      no: 3,
                      pkid: "1bb3f58d1581415e9c4d7b2e6dab81cd",
                      archivesTypeCode: "blq",
                      parentarea: 0,
                      channel: 4,
                      archivesId: "d646be65f6dd4867917c406b87df2c00",
                      sort: 10,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 642,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "永兴旺",
                      id: "3",
                    },
                    {
                      no: 5,
                      pkid: "615dbe9966fe499382627980213bd7ac",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 4,
                      archivesId: null,
                      sort: 11,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: 644,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "利兴强箱变",
                      id: "5",
                    },
                    {
                      no: -31,
                      pkid: "9e113ab6fa72435fb6ccd4602c8301bf",
                      archivesTypeCode: null,
                      parentarea: -1,
                      channel: 4,
                      archivesId: null,
                      sort: 35,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: -1,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "111",
                      id: "-31",
                    },
                    {
                      no: 67,
                      pkid: "c8537d9152304c5faab3baeec234587e",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 4,
                      archivesId: null,
                      sort: 51,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: null,
                      createTime: 1703228787000,
                      entityName: "VirtualDevicePojo",
                      label: "金盈毛绒工艺",
                      id: "67",
                    },
                  ],
                  no: 4,
                  fatherno: 3,
                  pkid: "4",
                  createTime: null,
                  entityName: "AppClassType",
                  label: "中山市电气",
                  unitid: "0A200022945047D7A5E538EDFC40FA2A",
                  id: "4",
                  sort: 2,
                  type: "group",
                  devicetype: 0,
                },
                {
                  children: [
                    {
                      no: 6,
                      pkid: "1868c55890bf4d63a177e4f9b8a31b7d",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 5,
                      archivesId: null,
                      sort: 10,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 929,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "永宁机电1数显表",
                      id: "6",
                    },
                    {
                      no: 7,
                      pkid: "d3bb0dd4f34a4071852980dfd5ea778d",
                      archivesTypeCode: "yjsbyq",
                      parentarea: 0,
                      channel: 5,
                      archivesId: "1fa0f05d829440b8b7baf4864097872f",
                      sort: 11,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 930,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "永宁机电2数显表",
                      id: "7",
                    },
                    {
                      no: 8,
                      pkid: "d1799f1509b647ec845c0af19afdcd86",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 5,
                      archivesId: null,
                      sort: 12,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 931,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "永宁机电3数显表",
                      id: "8",
                    },
                    {
                      no: 9,
                      pkid: "50726393360b491eb27b1a196203cf03",
                      archivesTypeCode: "dlhgq",
                      parentarea: 0,
                      channel: 5,
                      archivesId: "4e4f147cfbdf440587a225b86b18082a",
                      sort: 13,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 932,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "永宁机电5数显表",
                      id: "9",
                    },
                    {
                      no: 12,
                      pkid: "dca63d9156ed489682619a065ac59f7f",
                      archivesTypeCode: "dywnsdlq",
                      parentarea: 0,
                      channel: 5,
                      archivesId: "36c8919da433410998a3db3f8a1fecac",
                      sort: 14,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 935,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "永宁机电4数显表",
                      id: "12",
                    },
                    {
                      no: 14,
                      pkid: "e3fafcf4f97e43828b04bd6f9f9bdb7d",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 5,
                      archivesId: null,
                      sort: 15,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 1213,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "水元一4031厂房",
                      id: "14",
                    },
                    {
                      no: 15,
                      pkid: "062645a268214a2297abf4d4a6ae64ab",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 5,
                      archivesId: null,
                      sort: 16,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 1214,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "水元一4032厂房",
                      id: "15",
                    },
                    {
                      no: 17,
                      pkid: "b24c647db6e6433daa99f1d268f48f78",
                      archivesTypeCode: "PowerRoom",
                      parentarea: 0,
                      channel: 5,
                      archivesId: "e3b79844abcb4d7db0ef2100db24a9f0",
                      sort: 17,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 1216,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "气元一4034厂房",
                      id: "17",
                    },
                    {
                      no: 18,
                      pkid: "a084582dcd3842849d8e2024ae2e9ab4",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 5,
                      archivesId: null,
                      sort: 18,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 1217,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "气元一4035厂房",
                      id: "18",
                    },
                  ],
                  no: 5,
                  fatherno: 3,
                  pkid: "5",
                  createTime: null,
                  entityName: "AppClassType",
                  label: "科技产品有限公司",
                  unitid: "8643062D4DAF4FA0B1A4EA0A71713ED4",
                  id: "5",
                  sort: 3,
                  type: "group",
                  devicetype: 0,
                },
                {
                  children: [
                    {
                      no: 2,
                      pkid: "2261b6a7db9a4913b0b294626382c546",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 6,
                      archivesId: null,
                      sort: 26,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 641,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "奇源",
                      id: "2",
                    },
                    {
                      no: -28,
                      pkid: "ad368ab065ca46929e5acc6d79065326",
                      archivesTypeCode: null,
                      parentarea: -1,
                      channel: 6,
                      archivesId: null,
                      sort: 29,
                      type: "virtualDevice",
                      entityno: -1,
                      deviceaddr: -1,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "1D2-1+旁路开关（5#变）",
                      id: "-28",
                    },
                  ],
                  no: 6,
                  fatherno: 3,
                  pkid: "6",
                  createTime: 1671176351000,
                  entityName: "AppClassType",
                  label: "产品技有限公司",
                  unitid: "0281d0cc7fca4df8849e42687f55c617",
                  id: "6",
                  sort: 5,
                  type: "group",
                  devicetype: null,
                },
                {
                  children: [],
                  no: 7,
                  fatherno: 3,
                  pkid: "7",
                  createTime: 1672899963000,
                  entityName: "AppClassType",
                  label: "天津电力",
                  unitid: "9e0b4ec8962e4ab995f87b8294c5bcc0",
                  id: "7",
                  sort: 6,
                  type: "group",
                  devicetype: null,
                },
                {
                  children: [
                    {
                      no: 23,
                      pkid: "c72c650be4b242fb8a593ace2184640c",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 8,
                      archivesId: null,
                      sort: 33,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 0,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "设备no2",
                      id: "23",
                    },
                  ],
                  no: 8,
                  fatherno: 3,
                  pkid: "8",
                  createTime: 1678779056000,
                  entityName: "AppClassType",
                  label: "设备测试1",
                  unitid: "7fbf4d3b83174aa9b74a27ef582e1b9a",
                  id: "8",
                  sort: 7,
                  type: "group",
                  devicetype: null,
                },
                {
                  children: [
                    {
                      no: 25,
                      pkid: "9736aa35b3914794a87560b2e5f48c8d",
                      archivesTypeCode: "gsbyq",
                      parentarea: 0,
                      channel: 9,
                      archivesId: "2051de5f4cc14bbbb51cc74301a8fc44",
                      sort: 27,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 4,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "晔燃电表",
                      id: "25",
                    },
                    {
                      no: 26,
                      pkid: "ba57936fa86c4ce68df3946256213929",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 9,
                      archivesId: null,
                      sort: 28,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: 2,
                      createTime: null,
                      entityName: "VirtualDevicePojo",
                      label: "晔燃水表",
                      id: "26",
                    },
                    {
                      no: 43,
                      pkid: "9e4f2327b65345f192b3d17a99d97c56",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 9,
                      archivesId: null,
                      sort: 41,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: null,
                      createTime: 1703151369000,
                      entityName: "VirtualDevicePojo",
                      label: "设备测试0801",
                      id: "43",
                    },
                  ],
                  no: 9,
                  fatherno: 3,
                  pkid: "9",
                  createTime: null,
                  entityName: "AppClassType",
                  label: "上海科技",
                  unitid: "6C8D9A0A1B894AA3A585B57E928FD923",
                  id: "9",
                  sort: 8,
                  type: "group",
                  devicetype: 0,
                },
                {
                  children: [
                    {
                      no: 42,
                      pkid: "e960bbee46d244908f6b4392008fb462",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 10,
                      archivesId: null,
                      sort: 40,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: null,
                      createTime: 1703151364000,
                      entityName: "VirtualDevicePojo",
                      label: "设备测试0801",
                      id: "42",
                    },
                    {
                      no: 44,
                      pkid: "ef00a0a9854e4573b339c9b2583b7f96",
                      archivesTypeCode: null,
                      parentarea: 0,
                      channel: 10,
                      archivesId: null,
                      sort: 42,
                      type: "virtualDevice",
                      entityno: null,
                      deviceaddr: null,
                      createTime: 1703205165000,
                      entityName: "VirtualDevicePojo",
                      label: "益大",
                      id: "44",
                    },
                  ],
                  no: 10,
                  fatherno: 3,
                  pkid: "10",
                  createTime: null,
                  entityName: "AppClassType",
                  label: "配电房",
                  unitid: "FC0203DA14C845A4BA18E7F53DD5A4FC",
                  id: "10",
                  sort: 9,
                  type: "group",
                  devicetype: 0,
                },
              ],
              no: 3,
              fatherno: 2,
              pkid: "3",
              createTime: null,
              entityName: "AppClassType",
              label: "设备-1#站点",
              unitid: "1C00C7EDE52443B4A6F104C3C64BC219",
              id: "3",
              sort: 1,
              type: "group",
              devicetype: 0,
            },
            {
              children: [],
              no: 11,
              fatherno: 2,
              pkid: "11",
              createTime: 1705975642000,
              entityName: "AppClassType",
              label: "设备电气",
              unitid: "3fd6e0341cba4e99b81eb5c2e9db9eb3",
              id: "11",
              sort: 10,
              type: "group",
              devicetype: null,
            },
            {
              children: [],
              no: 12,
              fatherno: 2,
              pkid: "12",
              createTime: 1706154970000,
              entityName: "AppClassType",
              label: "测试1",
              unitid: "d763e1dc1cbe45c497aa68db38f4acda",
              id: "12",
              sort: 11,
              type: "group",
              devicetype: null,
            },
          ],
          no: 2,
          fatherno: 0,
          pkid: "2",
          createTime: null,
          entityName: "AppClassType",
          label: getName(),
          unitid: "B5A693FA77804BC8BE009D57D0E7A788",
          id: "2",
          sort: 4,
          type: "group",
          devicetype: 1,
        },
      ];

      return data;
      //  var data = this.$store.deviceStore.getters.getReadDeviceTree
      // return isempty(data) ? [] : [deviceList(data)]
    },

    // nowVirtualDeviceList () {
    //   return this.$store.deviceStore.state.saveEnergyDeviceList
    // },
    getBackgroudImageStyle() {
      return this.$store.resourcesStore.getters.getBackgroudImageStyle;
    },
    getResourcesByName() {
      return this.$store.resourcesStore.getters.getResourcesByName;
    },
    nowSelectDate() {
      return this.$store.cacheStore.getters.getNowSelectDate;
    },
    nowDateText() {
      return this.nowSelectDate.formatByDate("-");
    },
    deviceNoToVariableTree() {
      //debugger;
      if (isempty(this.nowVirtualDeviceList)) {
        return [];
      }
      var treeRes = {};
      this.nowVirtualDeviceList.forEach((item) => {
        if (item.type == "virtualDevice") {
          treeRes[item.no] = this.$store.variableStore.getters.getVariableTree(
            item.no
          );
        }
      });
      return treeRes;
    },
    getArchivesByDeviceNos() {
      return this.$store.archivesStore.getters.getArchivesByDeviceNos;
    },
    nowVariableList() {
      //当前应该使用变量列表
      if (isempty(this.nowApptypeGroup)) {
        return [];
      }
      var list = [];
      if (this.nowApptypeGroup.no == -1 || this.nowApptypeGroup.no == -2) {
        var newVariableToDeviceNo = {};
        //负荷率和负荷只要变量类型为31的变量
        var keys = Object.keys(this.deviceNoToVariableTree);
        keys.forEach((item) => {
          //debugger
          this.deviceNoToVariableTree[item].forEach((treeItem) => {
            for (var i2 = 0, len2 = treeItem.next.length; i2 < len2; i2++) {
              var item2 = treeItem.next[i2];
              if (
                item2.typeNo == 31 ||
                item2.typeNo == 237 ||
                item2.typeNo == 361
              ) {
                list.push(item2);
                newVariableToDeviceNo[item2.fromName] = item;
              }
            }
          });
        });
        this.variableToDeviceNo = newVariableToDeviceNo;
      } else {
        //功率因素
        var keys = Object.keys(this.deviceNoToVariableTree);
        keys.forEach((item) => {
          this.deviceNoToVariableTree[item].forEach((treeItem) => {
            if (treeItem.no == this.nowApptypeGroup.no) {
              for (var i2 = 0, len2 = treeItem.next.length; i2 < len2; i2++) {
                list.push(treeItem.next[i2]);
              }
            }
          });
        });
      }
      return list;
    },
    nowVariableNames() {
      if (isempty(this.nowVariableList)) {
        return [];
      }
      var list = [];
      for (var i = 0, len = this.nowVariableList.length; i < len; i++) {
        var item = this.nowVariableList[i];
        this.from2name[item.fromName] = item.name;
        list.push(item.fromName); //name == fromName
      }
      return list;
    },
    apptypeGroups() {
      return [
        //   {
        //   no: -2,
        //   name: '负荷率'
        // },
        {
          no: -1,
          name: "用电日负荷",
        },
        {
          no: 13,
          name: "功率因素",
        },
      ];
    },
    nowLoad() {
      //获取指定虚拟设备的额度负荷
      return (deviceNo) => {
        //当前虚拟变量关联的台账设备信息中的总功率配置
        if (deviceNo == undefined) {
          return undefined;
        }
        var info = this.getArchivesByDeviceNos([deviceNo])[0];
        if (info == undefined) {
          return undefined;
        }
        //查询类型typepropertycode为Power的配置
        var power = info.next.find((data) => {
          return data.propertyCode == "Power";
        });
        if (isempty(power) || isempty(power.value)) {
          return undefined;
        }
        return parseInt(power.value);
      };
    },
    getLoadByVariable() {
      //获取指定变量对应设备的配置的额定负荷
      return (key) => {
        var deviceNo = this.variableToDeviceNo[key];
        if (deviceNo == undefined) {
          return undefined;
        }
        return this.nowLoad(deviceNo);
        // return 200
      };
    },
    nowShowDataList() {
      return [
        [
          "设备机电总进线数显表.ATM",
          "37.26(11:42:17)",
          "27.30(10:54:26)",
          "33.56",
          "31.56",
          "32.56",
          "33.56",
          "34.56",
          "35.56",
          "31.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
          "33.56",
        ],
        [
          "气元一4033厂房.总有功功率",
          "105.90(10:48:58)",
          "80.10(10:10:51)",
          "89.89",
          "81.89",
          "82.89",
          "83.89",
          "84.89",
          "81.89",
          "81.89",
          "99.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
          "89.89",
        ],
        [
          "气元一4033厂房.正向有功电能",
          "0.37(09:42:21)",
          "0.32(11:23:52)",
          "0.34",
          "0.31",
          "0.32",
          "0.33",
          "0.36",
          "0.37",
          "0.31",
          "0.31",
          "0.32",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
          "0.34",
        ],
        [
          "水元一4011电线1211.正向有功电能",
          "0.47(09:42:21)",
          "0.3(11:23:52)",
          "0.44",
          "0.34",
          "0.41",
          "0.42",
          "0.41",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
          "0.44",
        ],
        [
          "水元一4011电线1211.总有功功率",
          "0.57(09:42:21)",
          "0.52(11:23:52)",
          "0.44",
          "0.51",
          "0.52",
          "0.53",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
          "0.54",
        ],
      ];
      //当前应该显示的数据列表，就是计算好的一天的每个整点值的数据
      if (this.nowApptypeGroup.no == -2) {
        if (isempty(this.nowVirtualDeviceList)) {
          return [];
        }
      }
      if (isempty(this.dataObject)) {
        return [];
      }
      var list = [];
      var keys = Object.keys(this.dataObject);

      for (var i = 0, len = keys.length; i < len; i++) {
        var key = keys[i];
        var name = this.from2name[key];
        var nList = [name];
        //加入最大值最小值和平均值
        var data = {};
        //var data = this.dataObject[key][0]
        //年度的data分开计算
        if (this.radioSelect == "year" || this.radioSelect == "quarter") {
          let monthData = this.dataObject[key];
          let dataArr = [];
          let monthDataCopy = monthData.filter((item) => item.max != -1.1111);

          // 根据 age 属性进行比较的自定义比较函数
          function compareByAge(a, b) {
            return a.max - b.max;
          }
          function compareByAgeMin(a, b) {
            return a.min - b.min;
          }
          var maxObj = monthDataCopy.reduce((prev, current) => {
            return compareByAge(prev, current) >= 0 ? prev : current;
          });
          var minObj = monthDataCopy.reduce((prev, current) => {
            return compareByAgeMin(prev, current) <= 0 ? prev : current;
          });
          monthData.forEach((item) => {
            if (!isempty(item.data)) {
              let itemData = Number(
                cutDigital(this.$historyTools.getAvg(item.data, item.avg))
              );
              dataArr.push(itemData);
            } else {
              dataArr.push(null);
            }
          });
          data.data = dataArr;
          data.avg = -1.11;
          data.maxtime = maxObj.date;
          data.mintime = minObj.date;
        } else {
          data = this.dataObject[key][0];
        }
        if (!isempty(data) && !isempty(data.data)) {
          if (this.nowApptypeGroup.no == -2) {
            var load = 100;
            load = this.getLoadByVariable(key);
            if (load == undefined || load == 0) {
              nList.push("- -");
              nList.push("- -");
              nList.push("- -");
            }
            nList.push(
              cutDigital(
                (this.$historyTools.getMax(data.data, data.max) / load) * 100
              ) + this.getMaxMinTime(data.maxtime)
            );
            nList.push(
              cutDigital(
                (this.$historyTools.getMin(data.data, data.min) / load) * 100
              ) + this.getMaxMinTime(data.mintime)
            );
            nList.push(
              cutDigital(
                (this.$historyTools.getAvg(data.data, data.avg) / load) * 100
              )
            );
          } else {
            nList.push(
              cutDigital(this.$historyTools.getMax(data.data, data.max)) +
                this.getMaxMinTime(data.maxtime)
            );
            nList.push(
              cutDigital(this.$historyTools.getMin(data.data, data.min)) +
                this.getMaxMinTime(data.mintime)
            );
            nList.push(
              cutDigital(this.$historyTools.getAvg(data.data, data.avg))
            );
          }
          data = data.data;
          if (this.radioSelect == "day") {
            //只要整点值
            data = data.filter((item, index) => {
              return index % 12 == 0;
            });
          }
          if (this.nowApptypeGroup.no == -2) {
            //计算负荷率
            nList.addAll(
              data.map((item) => {
                if (isnull(item)) {
                  return [];
                }
                return cutDigital((item / load) * 100);
              })
            );
          } else {
            //debugger
            nList.addAll(
              data.map((item) => {
                if (isnull(item)) {
                  return [];
                }
                return cutDigital(item);
              })
            );
          }
        }
        list.push(nList);
      }
      return list;
    },
    columns() {
      //列表的项，每个整点值
      var list = [];
      list.push(
        {
          name: "最大值",
          width: 180,
        },
        {
          name: "最小值",
          width: 180,
        },
        {
          name: "平均值",
        }
      );
      //debugger
      switch (this.radioSelect) {
        case "day":
          for (var i = 0; i < 24; i++) {
            list.push({
              name: (i < 10 ? "0" : "") + i + ":00",
            });
          }
          break;
        case "month":
          for (var i = 0; i <= 30; i++) {
            list.push({
              name: i + 1 + "日",
            });
          }
          break;
        case "quarter":
          var Month = [
            ["一月", "二月", "三月"],
            ["四月", "五月", "六月"],
            ["七月", "八月", "九月"],
            ["十月", "十一月", "十二月"],
          ];
          var quarter = parseInt((this.nowSelectDate.getMonth() + 3) / 3);
          var quarterList = Month[quarter - 1];
          for (var i = 0; i < 12; i++) {
            list.push({
              name: quarterList[i],
            });
          }
          break;
        case "year":
          name = name.subByFirstChar(".");
          for (var i = 0; i < 12; i++) {
            list.push({
              name: i + 1 + "月",
            });
          }
          break;
      }
      return list;
    },
  },
  watch: {
    radioSelect(nv, ov) {
      this.search();
    },
    nowShowDataList(nv, ov) {
      //获取到新的数据了，重新渲染
    },
    nowVariableNames(nv, ov) {
      if (this.mynum == 2 || this.mynum == 3) {
        if (nv.length != 0) {
          this.search();
        }
      }
    },
    nowSelectDate(nv, ov) {
      this.search();
    },
  },
  methods: {
    //树形结构选择
    checkFun(val) {
      this.mynum += 1;
      this.nowVirtualDevice = val;
      this.nowVirtualDeviceList = val;
    },
    //获取最大值和最小值的时间
    getMaxMinTime(dateTime) {
      let a = dateTime;
      let date = new Date(dateTime);
      let day = date.getDate();
      let month = date.getMonth();
      let hour = date.getHours();
      let minutes = date.getMinutes();
      let second = date.getSeconds();
      let returnStr = "";
      switch (this.radioSelect) {
        case "day":
          returnStr =
            "(" +
            (hour < 10 ? "0" : "") +
            hour +
            ":" +
            (minutes < 10 ? "0" : "") +
            minutes +
            ":" +
            (second < 10 ? "0" : "") +
            second +
            ")";
          break;
        case "month":
          returnStr = "(" + (day + 1) + "日" + ")";
          break;
        default:
          returnStr = "(" + (Number(month) + 1) + "月" + ")";
      }
      return returnStr;
    },
    downloadExcel() {
      let title = "<thead><tr>";
      title +=
        "<th colspan=6>" + new Date().formatByTime("-") + " 节能评估" + "</th>";
      title += "</tr></thead>";
      let aa = document.getElementsByTagName("thead")[0]; //头部表达
      let bb = document.getElementsByTagName("tbody")[0]; //列表内容
      let table = title + aa.innerHTML + bb.innerHTML;
      exportToExcel(table, "节能评估报告");
    },
    checkGroups(item) {
      this.nowApptypeGroup = item;
      //this.$store.deviceStore.commit('setSaveEnergyDeviceList', item)
    },
    checkItem(item) {
      this.$store.deviceStore.commit("setSaveEnergyDeviceList", item);
      this.search();
    },
    selectDate(date) {
      this.$store.cacheStore.commit("setNowSelectDate", date);
      this.$refs.datePicker.hide();
    },
    //下拉框选择
    select_fn() {
      var obj = [];
      obj = this.apptypeGroups.filter((item) => item.no == this.apptype);
      this.nowApptypeGroup = obj[0];
      // this.$store.deviceStore.commit('setSaveEnergyDeviceList', obj)
      this.search();
    },
    search() {
      var d = {
        tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
        legend: {
          data: [
            "设备机电总进线数显表.ATM",
            "气元一4033厂房.总有功功率",
            "气元一4033厂房.正向有功电能",
            "水元一4011电线1211.正向有功电能",
            "水元一4011电线1211.总有功功率",
          ],
          bottom: 0,
          selected: {},
        },
        grid: { top: 40, left: 50, right: 15, bottom: 30, containLabel: true },
        xAxis: {
          splitLine: { show: true },
          type: "category",
          axisTick: { show: false },
          axisLabel: { interval: 0, rotate: 0, inside: false },
          axisLine: { show: false },
          data: [
            "00:00",
            "01:00",
            "02:00",
            "03:00",
            "04:00",
            "05:00",
            "06:00",
            "07:00",
            "08:00",
            "09:00",
            "10:00",
            "11:00",
            "12:00",
            "13:00",
            "14:00",
            "15:00",
            "16:00",
            "17:00",
            "18:00",
            "19:00",
            "20:00",
            "21:00",
            "22:00",
            "23:00",
          ],
        },
        title: {
          left: "left",
          text: "2024-04-26",
          textStyle: { color: "#1a1a1a", fontSize: 16, fontWeight: "normal" },
        },
        yAxis: {
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: { type: "dashed", color: "#CCCCCC" },
          },
          type: "value",
        },
        series: [
          {
            name: "设备机电总进线数显表.ATM",
            type: "bar",
            data: [
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
            ],
            barMaxWidth: 50,
          },
          {
            name: "气元一4033厂房.总有功功率",
            type: "bar",
            data: [
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
            ],
            barMaxWidth: 50,
          },
          {
            name: "气元一4033厂房.正向有功电能",
            type: "bar",
            data: [
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
            ],
            barMaxWidth: 50,
          },
          {
            name: "水元一4011电线1211.正向有功电能",
            type: "bar",
            data: [
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
            ],
            barMaxWidth: 50,
          },
          {
            name: "水元一4011电线1211.总有功功率",
            type: "bar",
            data: [
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
              Math.floor(Math.random() * 10),
            ],
            barMaxWidth: 50,
          },
        ],
        toolbox: {
          show: true,
          showTitle: false,
          top: "-5",
          right: "50",
          feature: {
            magicType: {
              type: ["line", "bar", "stack", "tiled"],
              title: {
                line: "切换为折线图",
                bar: "切换为柱状图",
                stack: "切换为堆叠",
                tiled: "切换为平铺",
              },
            },
            saveAsImage: { show: true, title: "下载图片" },
          },
        },
      };
      this.$refs.vchart.setData(d, true);
    },

    dataSelectCheck() {
      //debugger
      if (this.radioSelect == "") {
        this.$dialogMethod.showMessage("请选择查询周期！");
        return false;
      }

      if (this.radioSelect == "day" && this.serchTime == "") {
        this.$dialogMethod.showMessage("日周期未选择时间！");
        return false;
      }

      if (
        (this.radioSelect == "month" && this.serchTime == "") ||
        (this.radioSelect == "quarter" && this.serchTime == "")
      ) {
        this.$dialogMethod.showMessage("月、季周期未选择时间！");
        return false;
      }

      if (this.radioSelect == "year" && this.serchTime == "") {
        this.$dialogMethod.showMessage("年周期未选择时间！");
        return false;
      }
      return true;
    },

    exportExcel() {},
  },
};
</script>

<style scoped lang="scss">
.energySaving {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;

    .tree-left {
      width: 3rem;
      height: 100%;
      padding: 12px;
      box-sizing: border-box;
      background-color: #fff;
      margin-right: 8px;

      .btns {
        display: flex;
        // justify-content: space-evenly;
        margin-bottom: 8px;

        button {
          margin-right: 12px;
        }

        .el-button--mini {
          padding: 7px 10px !important;
        }

        .el-button + .el-button {
          margin-left: 0px;
        }
      }

      .search {
        display: flex;
        justify-content: center;
        margin-bottom: 12px;
      }
    }

    .right-table {
      width: calc(100% - 3.08rem);
      height: 100%;
      padding: 2px 20px 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      position: relative;

      .mycharts {
        display: flex;

        .charts-left {
          width: 35%;
        }

        .charts-right {
          width: 70%;
        }
      }
    }
  }
}
</style>
